export default {
  config: {
    data_table_expire_days: 30
  },
  tags: ['limited-to-microsoft'],
  api: [
    {rule: '.*', allow: true},
  ],
  page: [
    {rule: 'getstarted/.*', allow: false},
    {rule: 'dashboard/resources', allow: false},
    {rule: 'dashboard/.*', allow: true},
    {rule: 'settings/blocklists', allow: false},
    {rule: 'settings/sensors', allow: false},
    {rule: 'settings/subnets', allow: false},
    {rule: 'settings/tags', allow: false},
    {rule: 'settings/pipelines', allow: false},
    {rule: 'settings/.*', allow: true},
    {rule: 'reporting/.*', allow: true},
    {rule: 'user/.*', allow: true},
  ],
  schema: [
    {
      rule: 'user',
      properties: {
        configAlerts:{
          'type':'object',
          properties:{
            voice_number: {'type':'string', 'readOnly': true },
            text_number: {'type':'string', 'readOnly': true },
          }
        }
      }
    }
  ]
}
